export default {
  relatorios: []
}
